import HeroStack from '../components/HeroStack.jsx';
import ProductDeepDive from '../components/product/ProductDeepDive.jsx';
import DemoCTA from '../components/DemoCTA.jsx';
import { PRODUCTS } from '../data/products.js';
import { useReveal } from '../lib/useReveal.js';

/* <LandingPage />
   ----------------------------------------------------------
   The whole site is a single, focused page:

     1. Hero  — grid + 2 floating product cards
     2. Theo  — the AI engine, its own world
     3. OpenCharts — the AI-native workspace, its own world
     4. CTA   — "See it in action", one button
     5. Footer — minimal

   No multi-product showcase, no rail, no compliance band.
   Visitors should land, read Theo, read OpenCharts, then
   book a walkthrough demo. */
export default function LandingPage() {
  useReveal();

  return (
    <>
      {/* HERO — grid background (atmosphere) + headline + 2 floating cards */}
      <header className="hero wrap" id="top">
        <div className="hero-grid">
          <div>
            <div className="eyebrow" data-reveal>
              ◇ &nbsp; Theo &nbsp; · &nbsp; OpenCharts
            </div>
            <h1 className="display" data-reveal style={{ transitionDelay: '.1s' }}>
              <span>The AI engine and</span>
              <br />
              <span className="serif gradient">the workspace it powers.</span>
            </h1>
            <p className="hero-sub" data-reveal style={{ transitionDelay: '.2s' }}>
              Theo is the AI engine for reasoning, generation, and execution.
              OpenCharts is the AI-native workspace it powers — flowcharts,
              presentations, vibe coding, podcasts, and notes on one canvas.
            </p>
            <div className="hero-cta-row" data-reveal style={{ transitionDelay: '.3s' }}>
              <DemoCTA variant="primary" source="hero" label="Book walkthrough demo" />
              <a className="btn-ghost" href="#product-theo">
                View product overview
              </a>
            </div>
          </div>
          <div className="hero-stack" data-reveal style={{ transitionDelay: '.2s' }}>
            <HeroStack />
          </div>
        </div>
      </header>

      {/* PRODUCT WORLDS — Theo first, OpenCharts second.
          Each gets its own section so the visual tone (accent
          gradient, hero stage) reads as distinct. */}
      {PRODUCTS.map((product, index) => (
        <section
          key={product.id}
          className="section"
          id={`section-${product.id}`}
          style={index === 0 ? { paddingTop: 40 } : undefined}
        >
          <div className="wrap">
            <ProductDeepDive product={product} />
          </div>
        </section>
      ))}

      {/* CTA BAND — single action: book walkthrough demo. */}
      <section className="section" id="contact" style={{ padding: '80px 0' }}>
        <div className="wrap">
          <div className="cta-band">
            <div className="cta-band__inner cta-band__inner--single">
              <div>
                <div className="eyebrow" style={{ color: 'var(--theo-a)' }}>◇ See it in action</div>
                <h2>
                  Book a walkthrough,
                  <br />
                  <span className="serif">see it work.</span>
                </h2>
                <p>
                  Book a walkthrough and explore how Theo and OpenCharts work together.
                </p>
                <div className="cta-band__buttons">
                  <DemoCTA variant="primary" source="cta-band" label="Book walkthrough demo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
